import { Loader2 } from "lucide-react";

/** Full-screen minimal loading state used while a route guard resolves. */
export function AuthLoading() {
  return (
    <div className="grid min-h-screen place-items-center bg-background text-muted-foreground">
      <div className="inline-flex items-center gap-2 text-sm">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>Loading…</span>
      </div>
    </div>
  );
}
